import React from 'react';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';
import BOLayout from '@/pages/back-office/BOLayout';

function SettingMenu() {
    return (
        <BOLayout>
            <div className="mb-4 grid grid-cols-1 gap-12">
                <h1 className="text-3xl font-bold text-center mt-4">Paramètres</h1>
            </div>
            <SettingsTopBanner />
        </BOLayout>
    );
}

export default SettingMenu;
